// price-filter-pagination.js
(function () {
  if (window.__pfPaginationLoaded) return; // double load se bachao
  window.__pfPaginationLoaded = true;

  var PAGE_PARAM = 'pf_page';

  function injectStyles() {
    if (document.getElementById('pf-pagination-styles')) return;
    var style = document.createElement('style');
    style.id = 'pf-pagination-styles';
    style.textContent =
      '.pf-pagination{display:flex;gap:8px;justify-content:center;margin-top:30px;flex-wrap:wrap;width:100%}' +
      '.pf-pagination__btn{min-width:36px;height:36px;border:1px solid #ddd;background:#fff;border-radius:50%;cursor:pointer;font-size:14px}' +
      '.pf-pagination__btn:hover:not(:disabled){border-color:#111}' +
      '.pf-pagination__btn.is-active{background:#111;color:#fff;border-color:#111}' +
      '.pf-pagination__btn:disabled{opacity:.4;cursor:not-allowed}';
    document.head.appendChild(style);
  }

  function makeButton(label, disabled, onClick) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = label;
    btn.className = 'pf-pagination__btn';
    btn.disabled = disabled;
    if (!disabled) btn.addEventListener('click', onClick);
    return btn;
  }

  function setup(grid) {
    var perPage = parseInt(grid.dataset.itemsPerPage, 10) || 24;

    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('grid__item');
    });
    if (!items.length) {
      items = Array.prototype.slice.call(grid.querySelectorAll('.grid__item'));
    }
    if (!items.length) return false;

    var totalPages = Math.ceil(items.length / perPage);

    var pager = document.getElementById('pf-custom-pagination');
    if (!pager) {
      pager = document.createElement('div');
      pager.id = 'pf-custom-pagination';
      pager.className = 'pf-pagination';
      grid.parentNode.insertBefore(pager, grid.nextSibling);
    }

    var params = new URLSearchParams(window.location.search);
    var currentPage = parseInt(params.get(PAGE_PARAM), 10) || 1;
    if (currentPage < 1) currentPage = 1;
    if (currentPage > totalPages) currentPage = totalPages;

    function renderPage(page, shouldScroll) {
      items.forEach(function (item, idx) {
        if (Math.floor(idx / perPage) + 1 === page) {
          item.style.removeProperty('display');
        } else {
          item.style.setProperty('display', 'none', 'important');
        }
      });
      renderPager(page);

      var p = new URLSearchParams(window.location.search);
      p.set(PAGE_PARAM, page);
      history.replaceState(null, '', '?' + p.toString());

      if (shouldScroll) {
        var c = document.getElementById('productgridcontainer') || grid;
        c.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderPager(page) {
      pager.innerHTML = '';
      if (totalPages <= 1) return;
      pager.appendChild(makeButton('‹', page === 1, function () { renderPage(page - 1, true); }));
      for (var n = 1; n <= totalPages; n++) {
        (function (pNum) {
          var btn = makeButton(String(pNum), false, function () { renderPage(pNum, true); });
          if (pNum === page) btn.classList.add('is-active');
          pager.appendChild(btn);
        })(n);
      }
      pager.appendChild(makeButton('›', page === totalPages, function () { renderPage(page + 1, true); }));
    }

    renderPage(currentPage, false);
    return true;
  }

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.pfActive !== 'true') return;

    // Is grid par pehle se pagination lag chuki hai, to skip
    var count = grid.querySelectorAll('.grid__item').length;
    if (grid.dataset.pfPaged === String(count)) return;

    injectStyles();
    if (setup(grid)) grid.dataset.pfPaged = String(count);
  }

  // 1) Turant ya DOM ready par
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // 2) Sab load hone ke baad (late-rendered grid ke liye)
  window.addEventListener('load', init);
  // 3) Shopify theme editor
  document.addEventListener('shopify:section:load', init);

  // 4) AJAX filter/sort se grid replace ho to dobara chalao
  var timer;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(init, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();